import React from 'react'
import { iconProps } from '../Helper'

const EditPinIcon = ({ className, source }: iconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16" fill="none">
        <path className={className} d="M10.601 6.66667L11.332 7.39778L4.2708 14.4444H3.55534V13.7289L10.601 6.66667ZM13.4006 2C13.2062 2 13.004 2.07778 12.8563 2.22556L11.4331 3.64889L14.3494 6.56556L15.7725 5.14222C16.0758 4.83889 16.0758 4.33333 15.7725 4.04556L13.9528 2.22556C13.7973 2.07 13.6028 2 13.4006 2ZM10.601 4.48111L2 13.0833V16H4.91626L13.5173 7.39778L10.601 4.48111Z" fill="#71787D"/>
    </svg>
  );
}

export default EditPinIcon
